import { SWITCH_TO_PAGE } from "./actionTypes";

export const switchpage = (path) => {
  return {
    type: SWITCH_TO_PAGE,
    payload: path
  };
};

